import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuestionnairesMenuItemComponent } from "../../../table-grid/features/questionnaires-list-page/components/questionnaires-menu-item/questionnaires-menu-item.component";
import { EQuestionnaireStatus, QuestionnaireRow } from 'src/app/models/questionnaireGrid.model';
import { QuestionnairesGridStore } from 'src/app/features/questionnaires/store/questionnairesGrid-store';
import { GlobalStore } from 'src/app/store/global-store';
import { toSignal } from '@angular/core/rxjs-interop';
import { EReplyStatus } from 'src/app/models/recipients.model';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { SaveNameListComponent } from 'src/app/features/create-questionnaire-page/component/question-form/components/save-name-list/save-name-list.component';
import { ManipulationsToolbarStore } from 'src/app/store/manipulations-toolbar-store';

@Component({
    selector: 'que-card',
    templateUrl: './card.component.html',
    styleUrls: ['./card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, QuestionnairesMenuItemComponent]
})
export class CardComponent {
    @Input()
    questionnaire?: QuestionnaireRow;
    #questionnaireGridStore = inject(QuestionnairesGridStore)
    #router = inject(Router)
    isRoleAdmin$ = toSignal(inject(GlobalStore).isRoleAdmin$);
    enumQStatus = EQuestionnaireStatus;
    enumReplyStatus = EReplyStatus;
    #dialog = inject(MatDialog)
    isDisplayUser$ = toSignal(inject(ManipulationsToolbarStore).isDisplayUser$)

    duplicate(event: Event) {
        event.stopPropagation();
        this.#dialog.open(SaveNameListComponent,
            {
                autoFocus: false,
                data: {
                    isDuplicateQuestionnairePopup: true,
                    name: this.questionnaire?.name,
                }
            }
        ).afterClosed()
            .subscribe((resultFromPopUp: string) => {
                if (resultFromPopUp) {
                    this.#questionnaireGridStore.duplicateQuestionnaire({ id: this.questionnaire?.id ?? 0, name: resultFromPopUp })
                }
            })
    }

    questionnaireClick() {
        if (!this.isDisplayUser$()) {
            if (this.questionnaire?.status == EQuestionnaireStatus.Edit) {
                this.edit();
            }
            else {
                this.navToData();
            }
        }
        else {
            if (this.questionnaire?.statusToUser != this.enumReplyStatus.Finished) {
                this.answerIt();
            }
        }
    }
    edit() {
        this.#router.navigate([`create`, `${this.questionnaire?.id}`])
    }
    navToData() {
        this.#router.navigate(['data', `${this.questionnaire?.id}`]);
    }
    answerIt(event?: Event) {
        event?.stopPropagation();
        if (this.questionnaire?.guidToUser)
            this.#router.navigate(['answer', `${this.questionnaire?.guidToUser}`])
    }
}
